import { Component, input } from '@angular/core';

export type ShimmerVariant = 'boot' | 'auth-form' | 'profile' | 'page';

@Component({
  selector: 'app-shimmer',
  template: `
    <div class="shimmer-wrap" [attr.data-variant]="variant()" aria-busy="true" aria-live="polite">
      @switch (variant()) {
        @case ('boot') {
          <div class="shimmer-boot">
            <aside class="shimmer-side">
              <span class="shimmer-bar w-40"></span>
              <span class="shimmer-bar w-70 mt"></span>
              <span class="shimmer-bar w-60 mt"></span>
              <span class="shimmer-bar w-80 mt"></span>
              <span class="shimmer-bar w-50 mt"></span>
            </aside>
            <div class="shimmer-main">
              <span class="shimmer-bar w-30"></span>
              <span class="shimmer-block lg mt"></span>
              <span class="shimmer-block md mt"></span>
            </div>
          </div>
        }
        @case ('auth-form') {
          <span class="shimmer-bar w-40"></span>
          <span class="shimmer-bar w-70 sm mt"></span>
          <span class="shimmer-block sm mt"></span>
          <span class="shimmer-block sm mt"></span>
          <span class="shimmer-block sm mt"></span>
          <span class="shimmer-block btn mt"></span>
        }
        @case ('profile') {
          <span class="shimmer-bar w-40"></span>
          <span class="shimmer-bar w-60 sm mt"></span>
          <div class="shimmer-hero mt">
            <span class="shimmer-avatar"></span>
            <div class="shimmer-hero-copy">
              <span class="shimmer-bar w-50"></span>
              <span class="shimmer-bar w-70 sm mt"></span>
            </div>
          </div>
          <span class="shimmer-block lg mt"></span>
          <span class="shimmer-block md mt"></span>
        }
        @default {
          <span class="shimmer-bar w-40"></span>
          <span class="shimmer-block lg mt"></span>
          <span class="shimmer-block md mt"></span>
          <span class="shimmer-block sm mt"></span>
        }
      }
    </div>
  `,
})
export class Shimmer {
  readonly variant = input<ShimmerVariant>('page');
}
